import React from "react";
import { MsalProvider } from "@azure/msal-react";
import { msalInstance } from "../services/msal/msalInstance";

interface AppMsalProviderProps {
  children: React.ReactNode;
}

const AppMsalProvider = ({
  children,
}: AppMsalProviderProps): React.ReactElement => {
  return <MsalProvider instance={msalInstance}>{children}</MsalProvider>;
};

export default AppMsalProvider;
